export default "__VITE_ASSET__BPUyF$iQ__"